// The open page lives in App state, not in a router, so a reload used to land on Live even with
// /predictions?tab=departures in the address bar. The page is now the URL path, so a reload or a
// shared link opens the same page. Admin-only pages are never restored from a URL: they are only
// reachable from the nav, which already checks roles.
export const URL_PAGES = [
  'history', 'predictions', 'airport', 'messages', 'airband', 'statistics', 'notams',
  'account', 'receivers', 'downloads', 'settings',
];

/** The page a path opens, or 'map' (Live) for '/' and anything unknown. */
export function pageFromPath(pathname) {
  const p = String(pathname || '').replace(/^\/+|\/+$/g, '');
  return URL_PAGES.includes(p) ? p : 'map';
}

/**
 * The URL to show for a page. A page's own query (Predictions' ?tab=) is kept while that page stays
 * open and dropped when another page opens, so it can't leak onto the next page.
 */
export function urlForPage(page, href) {
  const url = new URL(href);
  const path = URL_PAGES.includes(page) ? '/' + page : '/';
  if (url.pathname !== path) {
    url.pathname = path;
    url.search = '';
  }
  return url.toString();
}
